import React from 'react';
import {
  DoubleMaterialityAssessmentData,
  MaterialityAssessmentScope,
} from '@apps/materiality-tracker/api/materiality-assessment';
import { topicLengthMap } from '../../../../utils';
import { DataSource } from '@features/report-output/common';
import { BiDirectionalBarChart } from './BiDirectionalBarChart';
import { SingleBarChart } from './SingleBarChart';
import { PrioritizedAssessmentData } from '../../types';

export interface DataSources {
  doubleMaterialityTopics: DataSource;
  financialMaterialityChart: DataSource;
}

export interface GenerateChartsProps<T = DoubleMaterialityAssessmentData | PrioritizedAssessmentData> {
  updateData: (key: string, data: DataSource) => void;
  data: T[];
  sizeScope: MaterialityAssessmentScope;
}

export const GenerateCharts = React.memo(({ data, sizeScope, ...props }: GenerateChartsProps<DoubleMaterialityAssessmentData>) => {
  const topTopicsData = data.slice(0, topicLengthMap[sizeScope]);
  return (
    <div style={{ height: 0, width: 0, overflow: 'hidden' }}>
      <BiDirectionalBarChart {...props} data={topTopicsData} />
    </div>
  );
});

export const GenerateFinancialCharts = React.memo(({ data, sizeScope, updateData }: GenerateChartsProps<PrioritizedAssessmentData>) => {
  const topTopicsData = data.slice(0, topicLengthMap[sizeScope]);
  return (
    <div style={{ height: 0, width: 0, overflow: 'hidden' }}>
      <SingleBarChart data={topTopicsData} updateData={updateData} />
    </div>
  );
});
